import React from "react";
import {
  FormControl,
  Select,
  MenuItem,
  OutlinedInput,
  ListItemText,
} from "@mui/material";
import "../components.scss";
import { CustomCheckbox } from "../../../../../common/components";

interface RoleSelectProps {
  value: number | number[] | string;
  onChange: (value: number | number[]) => void;
  roles: { label: string; value: number | string }[];
  touched?: boolean;
  error?: any;
  isLabelled?: boolean;
  isRequired?: boolean;
  isMultiple?: boolean;
}

const RoleSelect: React.FC<RoleSelectProps> = ({
  value,
  onChange,
  roles,
  touched,
  error,
  isLabelled,
  isRequired,
  isMultiple = false,
}) => {
  const isSelected = (val: number | string): boolean =>
    Array.isArray(value) && value.includes(Number(val));

  const handleMultipleChange = (selectedValue: number | string) => {
    if (!Array.isArray(value)) return;
    const newValue = isSelected(selectedValue)
      ? value.filter((v) => v !== Number(selectedValue))
      : [...value, Number(selectedValue)];
    onChange(newValue);
  };

  const renderSelectedValues = (selected: any) => {
    if (!selected || (Array.isArray(selected) && selected.length === 0)) {
      return <div className="default-label">Select a role</div>;
    }
    if (isMultiple && Array.isArray(selected)) {
      return roles
        .filter((r) => selected.includes(Number(r.value)))
        .map((r) => r.label)
        .join(", ");
    }
    const selectedRole = roles.find(
      (role) => String(role.value) === String(selected)
    );
    return selectedRole ? selectedRole.label : <em>Unknown role</em>;
  };

  return (
    <FormControl
      fullWidth
      error={touched && !!error}
      className="user-management-select"
    >
      {isLabelled && (
        <label htmlFor="role-select" className="form-label">
          Role{isRequired && <span className="required-asterisk">*</span>}
        </label>
      )}
      <Select
        id="role-select"
        multiple={isMultiple}
        className="custom-role-select"
        value={value}
        onChange={() => {}}
        displayEmpty
        input={<OutlinedInput />}
        renderValue={renderSelectedValues}
        inputProps={{ "aria-label": "Role select" }}
      >
        {!isMultiple && (
          <MenuItem disabled value="">
            {roles.length > 0 ?<em>Select a role</em>: <em>Please select company to fetch roles</em>}
          </MenuItem>
        )}
        {roles.map((role) => (
          <MenuItem
            key={role.value}
            value={Number(role.value)}
            onClick={() => {
              isMultiple
                ? handleMultipleChange(role.value)
                : onChange(Number(role.value));
            }}
          >
            <ListItemText primary={role.label} />
            {isMultiple && (
              <CustomCheckbox
                checked={isSelected(role.value)}
                onChange={() => handleMultipleChange(role.value)}
                label={""}
              />
            )}
          </MenuItem>
        ))}
      </Select>
      {touched && error && <div className="error-message">{error}</div>}
    </FormControl>
  );
};

export default RoleSelect;